export const WORKSPACE_URL = "https://workspace.demaxtore.com/";
